import { CurrencyInputPipe } from '@hub/pipes/CurrencyInput.pipe'
import { Directive, HostListener, ElementRef, Input, Output, OnInit, EventEmitter  } from "@angular/core";

@Directive({
  selector: "[currencyFormatter]"
})
export class CurrencyFormatterDirective implements OnInit  {

  constructor(
    private elementRef: ElementRef,
  ) {
    this.el = this.elementRef.nativeElement;
  }

  @Input() value: number;
  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();

  private el: HTMLInputElement;
  private currencyPipe: CurrencyInputPipe = new CurrencyInputPipe();
  ngOnInit() {
  }

  @HostListener("focus", ["$event.target.value"])
  onFocus(value) {
    this.el.value = this.currencyPipe.parse(value); // opossite of transform
  }

  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {
    if (value === "") {
      value = 0;
    }
    this.el.value = this.currencyPipe.transform(value);
    this.value = Number.parseFloat(value);
    this.valueChange.emit(this.value);
  }

}
